import React from 'react';
import classNames from 'classnames';
import { useField } from 'formik';
import Label from '../lib/Label';
import Error from '../lib/Error';
import Container from '../lib/Container';

const defaultOptions = [{
    value: 'car',
    label: 'Auto'
},{
    value: 'moto',
    label: 'Moto'
},{
    value: 'van',
    label: 'Furgone'
},{
    value: 'camper',
    label: 'Camper'
},{
    value: 'bus',
    label: 'Bus'
}]

export default function CarTypeInput(props) {

    const {
        label,
        name,
        readOnly,
        fieldId,
        onChange,
        options,
        required,
        single,
        images
    } = props

    const [field, meta] = useField({
        name,
        readOnly,
        id: fieldId || name
    });

    function onChangeHandler(event) {
        const value = event.target.value;

        if (onChange && typeof onChange === 'function') {
            onChange(value, name)
        }
        return field.onChange(event);
    }

    const finalOptions = options || defaultOptions

    return (
        <Container noMargin>
            <div className="input-element-container relative">
                <Label
                    label={label}
                    name={name}
                    fieldId={fieldId}
                    relative
                    required={required}
                />

                <div className='flex flex-wrap gap-2'>
                    {finalOptions?.map((option, index) => {

                        const selected = field?.value?.includes(option.value)

                        const ContainerClasses = classNames({
                            "relative max-w-100 items-center border rounded-lg mt-2 box-border overflow-hidden": true,
                            "p-3": !images,
                            "p-1.5 pb-3": images,
                            "bg-light border-black": selected,
                            "border-line": !selected,
                            "border-red": meta?.error,
                        })

                        const InputClasses = classNames({
                            "absolute opacity-0 cursor-pointer w-full h-full top-0 left-0 appearance-none": true,
                            "hover:bg-light bg-white": !selected,
                            "bg-lightprimary": selected,
                        })
                    
                        return (
                            <div key={index} className={ContainerClasses}>
                                <input 
                                    {...field}
                                    id={option.value}
                                    value={option.value}
                                    type={single ? 'radio' : 'checkbox'}
                                    className={InputClasses}
                                    onChange={onChangeHandler}
                                />
                                {images &&
                                    <div className='w-16 h-16 rounded-lg bg-center bg-cover block mx-auto mb-1' style={{backgroundImage: `url("/images/car-types/${option.value}.jpg")`}} />
                                }
                                <div className='relative z-1 text-center text-sm pointer-events-none'>{option.label}</div>
                            </div>
                        )
                    })}
                </div>
            </div>

            {meta?.error && (
                <Error error={meta.error} left/>
            )}
        </Container>
    )
}
